import { connect } from "react-redux";

import { getIvrSoundList } from "actions/ivr_sounds";
import PageIvrSounds from "./PageIvrSounds";


const mapState = ({ ivr_sounds }) => ({
    data: ivr_sounds.list,
    loading: ivr_sounds.loading,
});

export default connect(mapState, {
    getIvrSoundList,
})(PageIvrSounds);